.plan-user-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: var(--lineup-plan-grid-row-user-count-label) / var(--lineup-plan-grid-row-analytics-license-label);
  gap: var(--space-0);
}

.read-only-users {
  grid-area: user-count;
  display: flex;
  align-items: center;
  color: var(--gray-212c36);
}

.user-input {
  grid-area: user-count;
  height: 32px;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  font-size: 14px;

  > input {
    text-align: left;
  }
}
